import React from 'react';

// Generic confirm-action modal. The caller sets `message` and
// `onConfirm` when they want to gate a destructive operation.
export default function ConfirmModal({ show, message, onCancel, onConfirm, playClickSound }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90]">
      <div className="bg-white text-black rounded-xl shadow-lg p-6 w-full max-w-sm">
        <h3 className="text-lg font-bold mb-4">Please Confirm</h3>
        <p className="mb-6">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            className="border px-4 py-2 rounded"
            onClick={() => { playClickSound(); onCancel(); }}
          >
            Cancel
          </button>
          <button className="bg-red-600 text-white px-4 py-2 rounded" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
